<template>
  <div v-if="isShowSearch" style="height:100%" class="yxtbiz-select-catelog">
    <yxt-input
      v-if="isShowSearch"
      v-model="catalogName"
      :placeholder='$t("pc_biz_kng_lbl_search_category_name"/* 搜索分类名称 */)'
      maxlength="20"
      searchable
      @search="searchCatalog"
    />
    <yxt-tree 
      class="select-kng-catalog__calc-height mt16"
      ref="kngTree"
      v-loading="treeLoading"
      :data="kngTreeData"
      :props="defaultProps"
      :wrap-width="wrapWidth"
      :current-node-key="currentId"
      node-key="id"
      @node-click="nodeClick"
      @current-change="currentNodeChange"
      :filter-node-method="filterCatalogNode"
      :default-checked-keys="checkLists"
      :default-expanded-keys="expandCatalog"
      :check-strictly="checkStrictly"
      :highlight-current="!isNeedCheck"
      :show-checkbox="isNeedCheck">
    </yxt-tree>
  </div>
  <yxt-tree
    v-else
    class="select-kng-catalog mt16"
    ref="kngTree"
    v-loading="treeLoading"
    :data="kngTreeData"
    :props="defaultProps"
    :wrap-width="wrapWidth"
    :current-node-key="currentId"
    node-key="id"
    @node-click="nodeClick"
    @current-change="currentNodeChange"
    :filter-node-method="filterCatalogNode"
    :default-checked-keys="checkLists"
    :default-expanded-keys="expandCatalog"
    :check-strictly="checkStrictly"
    :highlight-current="!isNeedCheck"
    :show-checkbox="isNeedCheck">
  </yxt-tree>
</template>

<script>
import api from './service';
import {enmuFunctions} from '../../function-points';
import commonUtil from '../../common-util';

import {
  Tree
} from 'yxt-pc';
export default {
  name: 'YxtbizSelectKngCatalog',
  name_zh: '选择课程分类',
  components: {
    YxtTree: Tree
  },
  eventList: [{
    type: 'change',
    handler: 'current-node-change',
    label: '选中节点变更'
  }, {
    type: 'change',
    handler: 'click-node',
    label: '节点被点击'
  }],
  props: {
    collegeId: {
      type: String,
      default: '',
      desc: '学院ID 如果不传获取全部的目录',
      setter: 'StringSetter'
    },
    currentCategoryId: {
      type: String,
      default: '',
      desc: '选中某个节点并展开父节点，传值后 currentFirstNode 属性失效',
      setter: 'StringSetter'
    },
    currentFirstNode: {
      type: Boolean,
      default: false,
      desc: '选中首个节点并且触发节点变更事件，isNeedCheck 和 currentCategoryId 开启后这个属性失效',
      setter: 'BooleanSetter'
    },
    rootCanCheck: {
      type: Boolean,
      default: false,
      desc: '多选时根目录是否显示checkbox',
      setter: 'BooleanSetter'
    },
    rootCanSelect: {
      type: Boolean,
      default: false,
      desc: '单选时根目录是否可以被选中',
      setter: 'BooleanSetter'
    },
    wrapWidth: {
      type: [String, Number],
      default: 320,
      desc: '树的宽度设置',
      setter: 'NumberSetter'
    },
    checkLists: {
      type: Array,
      default: () => [],
      desc: '多选时初始化默认勾选的选项',
      setter: 'JsonSetter'
    },
    isNeedCheck: {
      type: Boolean,
      default: true,
      desc: '是否需要树有多选（树结构有checkbox）	',
      setter: 'BooleanSetter'
    },
    checkId: {
      type: String,
      default: '',
      desc: '单选时初始化传入组件的默认选中id',
      setter: 'StringSetter'
    },
    checkStrictly: {
      type: Boolean,
      default: true,
      desc: '多选时是否遵循父子不关联',
      setter: 'BooleanSetter'
    },
    isExpandCatalog: {
      type: Boolean,
      default: false,
      desc: '是否默认需要目录展开一级',
      setter: 'BooleanSetter'
    },
    pmType: {
      type: Number,
      default: 0,
      desc: '需要目录的权限(0 浏览;1下载;2分发;3上传;4维护;5审核)',
      setter: 'SelectSetter',
      enums: [
        {
          label: '浏览',
          value: 0
        },
        {
          label: '下载',
          value: 1
        },
        {
          label: '分发',
          value: 2
        },
        {
          label: '上传',
          value: 3
        },
        {
          label: '维护',
          value: 4
        },
        {
          label: '审核',
          value: 5
        },
        {
          label: 'App缓存课件',
          value: 6
        }
      ]
    },
    isShowDisabledCollege: {
      type: Boolean,
      default: false,
      desc: '如果希望在企课堂被禁用或者已过期后仍然能选择到子课堂目录的话，这个值传true。',
      setter: 'BooleanSetter'
    },
    isShowSearch: {
      type: Boolean,
      default: false,
      desc: '是否显示搜索框，这个值为true时分类树的高度会自动根据组件父级高度出现滚动条',
      setter: 'BooleanSetter'
    },
    sourceType: {
      type: String,
      default: '',
      desc: '目前只对讲师有特殊处理，在传te同时传了 collegeId参数的时候将选中第一个子节点并触发 current-node-change 事件。，可选值： te',
      setter: 'StringSetter'
    },
    filterClosedCollegeData: {
      type: Boolean,
      default: false,
      desc: '是否过滤未开启的课堂的目录',
      setter: 'BooleanSetter'
    }
  },
  data() {
    return {
      treeLoading: true, // loading-tree
      kngTreeData: [], // 目录树的数据
      defaultProps: {
        children: 'children', // 默认子集的字段
        label: 'label', // 默认标题的字段
        nocheck: this.nocheckFilter
      },
      singleTree: {},
      // 不可选的列表 用于过滤不可点击
      nocheckList: [],
      // 需要展开节点的列表
      expandCatalog: [],
      catalogName: '',
      currentId: ''
    };
  },
  watch: {
    collegeId: {
      handler() {
        this.getCatalogInfo();
      },
      immediate: true
    }
  },
  methods: {
    // 获取知识库目录
    async getCatalogInfo() {
      this.treeLoading = true;
      let request = {
        pmType: this.pmType,
        filter: this.filterClosedCollegeData ? 1 : 0
      };
      if (this.collegeId) {
        request.collegeId = this.collegeId;
      }
      try {
        await commonUtil.preCheckFunctions(enmuFunctions);
        let res = await api.getKngTreeNew(request);
        if (res && res.length) {
          const val = commonUtil.checkTimeOutFnc(enmuFunctions.ONLINE_ClASS_SELECT_CATALOG);
          // 如果未增购企课堂，只显示主学院，如果传参要求显示禁用课堂就不再过滤
          if (val !== undefined && !(val >= 2 && val <= 4) && !this.isShowDisabledCollege) {
            res = res.filter(item => {
              return item.mainCollege;
            });
          }
          this.kngTreeData = res;
          if (this.isExpandCatalog) {
            // 展开第一层目录
            res.forEach(item => {
              this.expandCatalog.push(item.id);
            });
          }
          // 如果要选中第一个学院
          if (this.currentFirstNode && !this.isNeedCheck) {
            // 取出第一个节点id设置选中
            this.$nextTick(() => {
              this.$refs.kngTree && this.$refs.kngTree.setCurrentKey(res[0].id);
              this.currentNodeChange(res[0]);
            });
            // 不展开任何目录
            this.expandCatalog = [];
          }
          // 如果传了选中节点
          if (this.currentCategoryId) {
            this.$nextTick(()=>{
              this.$refs.kngTree && this.$refs.kngTree.setCurrentKey(this.currentCategoryId);
              if (this.$refs.kngTree) {
                let node = this.$refs.kngTree.getNode(this.currentCategoryId);
                // 展开选中节点的父级节点
                this.expandCatalog = [node.data.parentId];
              }
            });
          } else if (this.collegeId && this.sourceType === 'te') { // 如果传了collegeId 而且是讲师那边调用的
            let item = res.length && res[0];
            item = item.children && item.children.length && item.children[0];
            let currentId = item && item.id;
            if (currentId) {
              this.$nextTick(() => {
                this.$refs.kngTree.setCurrentKey(currentId);
                this.expandCatalog = [item.parentId];
              });
            }
          }
          // 如果显示复选框的情况下，默认不可选根目录
          if (this.isNeedCheck && !this.rootCanCheck || !this.isNeedCheck && !this.rootCanSelect) {
            res.forEach(item => {
              this.nocheckList.push(item.id);
            });
          }
          // 单选时设置选中项
          if (!this.isNeedCheck && this.checkId.length > 0) {
            this.$nextTick(() => {
              this.$refs.kngTree.setCurrentKey(this.checkId);
              this.singleTree = this.$refs.kngTree.getCurrentNode();
            });
          }
        }
      } catch (err) {
        console.log(err);
      }
      this.treeLoading = false;
    },
    // 单击目录时的选择
    nodeClick(item) {
      // 如果选择了一级目录 取消选中
      if (this.nocheckList.includes(item.id)) {
        this.$refs.kngTree.setCurrentKey(null);
        return false;
      }
      this.singleTree = item;
      this.$emit('click-node', item.id, item);
    },
    // 获取选中树数据id
    getCheckTree() {
      if (this.isNeedCheck) {
        if (this.$refs.kngTree) {
          let treeLists = this.$refs.kngTree.getCheckedNodes();
          let tempLists = [];
          treeLists.map(item => {
            let obj = {
              label: item.label,
              id: item.id
            };
            tempLists.push(obj);
          });
          return tempLists;
        }
        return [];
      } else {
        return this.singleTree;
      }
    },
    // 检查节点是否显示复选框
    nocheckFilter(data) {
      return this.nocheckList.includes(data.id);
    },
    // 搜索框触发事件
    searchCatalog(value) {
      this.$refs.kngTree && this.$refs.kngTree.filter(value);
    },
    // 根据分类名称过滤分类树
    filterCatalogNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    // 选中指定节点
    setCurrentNode(categoryId) {
      if (categoryId) {
        this.$nextTick(() => {
          this.$refs.kngTree.setCurrentKey(categoryId);
        });
      }
    },
    // 选择节点变更
    currentNodeChange(data) {
      this.$emit('current-node-change', data.id, data);
    },
    // 获得选中节点
    getCurrentNode() {
      return this.$refs.kngTree.getCurrentNode();
    }
  }
};
</script>
